import { __assign, __extends, __rest } from "tslib";
import React, { Component } from 'react';
import { PnmacPageBubble, PnmacSectionListView, PnmacRowHeader, PnmacMediaQuery, PnmacMeta, PnmacNavigation } from 'pnmac-universal-components';
import { Route, Switch } from 'react-router';
import { View, Image } from 'react-native';
import ContactInformation from './ContactInformation';
import LanguagePreferences from './LanguagePreferences';
import Loans from './Loans';
import MessageCenterNotifications from './MessageCenterNotifications';
import PaperlessPreferences from './PaperlessPreferences';
import Password from './Password';
import PrivacyPreferences from './PrivacyPreferences';
import SecurityQuestions from './SecurityQuestions';
import TwoFactorAuthentication from './TwoFactorAuthentication';
import UserName from './UserName';
import Edisbursments from './Edisbursments';
import { connect } from "react-redux";
import * as Actions from "../../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { getActiveFeatures } from '../../utils.js';
import styles from '../../styles/styles.js';
import Tooltip from '@material-ui/core/Tooltip';
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events.js';
import { textStyle } from "../../v2/theme";
import CommunicationNotificationView from './communication/CommunicationNotificationView';
var PnmacToolTip = function (_a) {
  var title = _a.title,
    children = _a.children;
  return /*#__PURE__*/React.createElement(Tooltip, {
    style: textStyle.defaultTextDescription,
    title: title
  }, children);
};
var AccountSettingsPage = /** @class */function (_super) {
  __extends(AccountSettingsPage, _super);
  function AccountSettingsPage(props) {
    var _this = _super.call(this, props) || this;
    _this.col = /*#__PURE__*/React.createRef();
    return _this;
  }
  AccountSettingsPage.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      translations = _a.translations,
      props = __rest(_a, ["translations"]);
    var list = [{
      name: translations.UserName,
      route: "Account/UserName",
      canExpand: false,
      action: "UserName",
      internal: true
    }, {
      name: translations.Password,
      route: "Account/ChangePassword",
      canExpand: false,
      action: "Password",
      internal: true
    }, {
      name: translations.TwoFactorAuthentication,
      route: "Account/TwoFactorAuthentication",
      canExpand: false,
      action: "TwoFactorAuthentication",
      internal: true
    }, {
      name: translations.ContactInformation,
      route: "Account/ContactInformation",
      canExpand: false,
      action: "ContactInformation",
      internal: true
    }, {
      name: translations.AddALoan,
      route: "Account/LoanAssociation",
      canExpand: false,
      action: "Loan",
      internal: true
    }, {
      name: translations.PrivacyPreferences,
      route: "Account/PrivacyPreferences",
      canExpand: false,
      action: "PrivacyPreferences",
      internal: true
    }, {
      name: translations.Communications,
      route: "Account/Communications",
      canExpand: false,
      action: "Communications",
      internal: true
    }, {
      name: translations.PaperlessPreferences,
      route: "Account/PaperlessPreferences",
      canExpand: false,
      action: "PaperlessPreferences",
      internal: true
    }, {
      name: translations.LanguagePreferences,
      route: "Account/LanguagePreferences",
      canExpand: false,
      action: "LanguagePreferences",
      internal: true
    }, getActiveFeatures(props.layout.features, "ShowEdisbursment") && {
      name: translations.eDisbursements,
      route: "Account/eDisbursement",
      canExpand: false,
      action: "Edisbursments",
      internal: true
    }].filter(function (s) {
      return s;
    });
    var DATAEXPANDABLE = [{
      title: "".concat(translations.AccountSettings),
      data: list.map(function (s, i) {
        return {
          header: "".concat(translations.AccountSettings),
          value: function () {
            return /*#__PURE__*/React.createElement("div", {
              style: textStyle.formBody,
              key: i,
              onClick: function () {
                var _a, _b;
                _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.div, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "click on " + s.action.toString() + " link", 253);
                var d = (_b = (_a = _this.col) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.collapseItem("".concat(translations.AccountSettings));
                if (s.internal && getActiveFeatures(props.layout.features, "View_".concat(s.action), props.layout.whitelisted)) {
                  PnmacNavigation(__assign({
                    action: {
                      pathname: "/".concat(s.route)
                    }
                  }, props));
                } else {
                  props.clearListCookies({
                    nav: "".concat(props.layout.baseRoute).concat(s.route),
                    loading: true,
                    logout: false
                  });
                }
              }
            }, s.name);
          }
        };
      })
    }];
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: matches.small ? 0 : 20,
          marginRight: matches.small ? 0 : 20
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.accountSettings
      }), /*#__PURE__*/React.createElement(PnmacPageBubble, {
        accessibilityRole: "header",
        ariaLevel: "1",
        containerStyles: {
          marginTop: 0,
          marginLeft: 0,
          marginBottom: 0
        },
        text: translations.accountSettings
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacSectionListView, {
        ref: _this.col,
        openDefaults: [translations === null || translations === void 0 ? void 0 : translations.AccountSettings],
        data: DATAEXPANDABLE,
        collapsableSections: true,
        renderItem: function (_a, collapsed) {
          var _b, _c, _d;
          var index = _a.index,
            item = _a.item;
          var notLastElement = index <= ((_c = (_b = DATAEXPANDABLE.find(function (title) {
            return title.title == item.header;
          })) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.length) - 2;
          if (collapsed.some(function (s) {
            return s == item.header;
          })) {
            return /*#__PURE__*/React.createElement("div", {
              style: __assign(__assign({}, (_d = styles.selectionListView) === null || _d === void 0 ? void 0 : _d.rowItemStyles), {
                marginBottom: notLastElement ? 0 : 10,
                borderBottomLeftRadius: notLastElement ? 0 : 10,
                borderBottomRightRadius: notLastElement ? 0 : 10,
                cursor: "pointer"
              }),
              key: item.header + 'index' + index
            }, item.value());
          } else {
            return null;
          }
        },
        renderSectionHeader: function (_a) {
          var _b, _c, _d, _e;
          var title = _a.section.title;
          var open = ((_c = (_b = _this.col) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1;
          return /*#__PURE__*/React.createElement(PnmacRowHeader, {
            rowHeaderStyles: styles.selectionListView.rowHeaderStyles,
            rowHeaderContainerStyles: {
              borderBottom: open ? "1px solid #e9e9e9" : "none",
              borderBottomLeftRadius: open ? 0 : 10,
              borderBottomRightRadius: open ? 0 : 10
            },
            onClickExpand: function () {
              return _this.col.current.collapseItem(title);
            },
            item: /*#__PURE__*/React.createElement(PnmacToolTip, {
              title: "Expand 1" + title
            }, /*#__PURE__*/React.createElement("div", {
              style: __assign({
                alignSelf: "center"
              }, textStyle.formTitleSection),
              onClick: function () {
                if (window.location.toString().indexOf('Account/eDisbursement') > -1) {
                  PnmacNavigation(__assign({
                    action: {
                      pathname: "/".concat("Account/AccountSetting")
                    }
                  }, _this.props));
                }
              }
            }, title)),
            isExpand: ((_e = (_d = _this.col) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.state.collapsed.indexOf(title)) > -1
          });
        }
      })), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/Account/UserName",
        render: function (props) {
          return /*#__PURE__*/React.createElement(UserName, __assign({
            matches: matches
          }, props));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/Account/ChangePassword",
        render: function (props) {
          return /*#__PURE__*/React.createElement(Password, __assign({
            matches: matches
          }, props));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/Account/TwoFactorAuthentication",
        render: function (props) {
          return /*#__PURE__*/React.createElement(TwoFactorAuthentication, __assign({
            matches: matches
          }, props));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/Account/ContactInformation",
        render: function (props) {
          return /*#__PURE__*/React.createElement(ContactInformation, __assign({
            matches: matches
          }, props));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/Account/LoanAssociation",
        render: function (props) {
          return /*#__PURE__*/React.createElement(Loans, __assign({
            matches: matches
          }, props));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/Account/PrivacyPreferences",
        render: function (props) {
          return /*#__PURE__*/React.createElement(PrivacyPreferences, __assign({
            matches: matches
          }, props));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/Account/Communications",
        render: function (props) {
          return /*#__PURE__*/React.createElement(CommunicationNotificationView, __assign({
            matches: matches
          }, props));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/Account/PaperlessPreferences",
        render: function (props) {
          return /*#__PURE__*/React.createElement(PaperlessPreferences, __assign({
            matches: matches
          }, props));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/Account/LanguagePreferences",
        render: function (props) {
          return /*#__PURE__*/React.createElement(LanguagePreferences, __assign({
            matches: matches
          }, props));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/Account/eDisbursement",
        render: function (props) {
          return /*#__PURE__*/React.createElement(Edisbursments, __assign({
            matches: matches
          }, props));
        }
      }))));
    });
  };
  return AccountSettingsPage;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountSettingsPage);